import React, { memo } from 'react';

import { Typography } from 'antd';
import TMIcon from 'tm-icons-library';

import { useTheme } from '../../context/ThemeProvider';
import { MEDIA_CONTENT } from '../../shared/constants';
import { ChatMediaType } from '../../types/communityMessagesTypes';

const ICON_SIZE = 20;

interface Props {
  type: ChatMediaType;
  file: File;
  contentUrl: string;
  onRemove: () => void;
  style?: React.CSSProperties;
  wrapperStyle?: React.CSSProperties;
}

const ChatInputFilePreview: React.FC<Props> = ({
  type,
  file,
  contentUrl,
  onRemove,
  style,
  wrapperStyle,
}) => {
  const { colors: COLORS } = useTheme();

  return (
    <div className="chat-input__file__preview" style={style}>
      {type === 'image' ? (
        <div
          className="chat-input__file chat-input__file--image"
          style={wrapperStyle}>
          <img src={contentUrl} alt={file.name} />
        </div>
      ) : null}

      {type === 'video' ? (
        <div
          className="chat-input__file chat-input__file--video"
          style={wrapperStyle}>
          <video src={contentUrl} />
          <TMIcon
            name="play"
            size={ICON_SIZE}
            color={COLORS.WHITE}
            className="chat-input__file__play-btn"
          />
        </div>
      ) : null}

      {type === 'audio' ? (
        <div
          className="chat-input__file chat-input__file--audio"
          style={wrapperStyle}>
          <span className="chat-input__file__icon">
            <TMIcon
              name={MEDIA_CONTENT.audio.icon}
              size={ICON_SIZE}
              color="currentColor"
            />
          </span>
          <Typography.Text
            className="chat-input__file__title"
            ellipsis={{ tooltip: file.name }}>
            {file.name}
          </Typography.Text>
        </div>
      ) : null}

      {type === 'doc' ? (
        <div
          className="chat-input__file chat-input__file--doc"
          style={wrapperStyle}>
          <span className="chat-input__file__icon">
            <TMIcon
              name={MEDIA_CONTENT.doc.icon}
              size={ICON_SIZE}
              color="currentColor"
            />
          </span>
          <Typography.Text
            className="chat-input__file__title"
            ellipsis={{ tooltip: file.name }}>
            {file.name}
          </Typography.Text>
        </div>
      ) : null}

      <span
        className="chat-input__file__preview__close-btn"
        onClick={onRemove}
        style={{ cursor: 'pointer' }}>
        <TMIcon name="close" size={12} color={COLORS.WHITE} />
      </span>
    </div>
  );
};

export default memo(ChatInputFilePreview);
